module.exports = __webpack_public_path__ + "static/sample-26-ba8645ce1b302057abac0f624195cb4e.png";